import { render, staticRenderFns } from "./EtfSizeChart.vue?vue&type=template&id=65436120&scoped=true"
import script from "./EtfSizeChart.vue?vue&type=script&lang=js"
export * from "./EtfSizeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65436120",
  null
  
)

export default component.exports